import { createParser } from "nuqs";
import {
	UTILITY_CONSUMPTION_MODE,
	UTILITY_CONSUMPTION_PERIOD_NAME,
	type UtilityConsumptionMode,
} from "../models/UtilityConsumption";

const MODE_BY_PERIOD_NAME: Record<string, UtilityConsumptionMode> = {
	day: UTILITY_CONSUMPTION_MODE.DATE,
	week: UTILITY_CONSUMPTION_MODE.WEEK,
	month: UTILITY_CONSUMPTION_MODE.DAY,
	year: UTILITY_CONSUMPTION_MODE.MONTH,
};

export const parseAsUtilityConsumptionMode = createParser({
	parse: (value: string) => MODE_BY_PERIOD_NAME[value] ?? null,
	serialize: (mode: UtilityConsumptionMode) =>
		UTILITY_CONSUMPTION_PERIOD_NAME[mode],
});
